"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecaptchaDisclaimer = exports.RecaptchaContent = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var frontend_typography_1 = require("@ryerson/frontend.typography");

exports.RecaptchaContent = {
  en: {
    protect: "This site is protected by reCAPTCHA and the Google",
    privacyPolicy: "Privacy Policy",
    and: "and",
    termsOfService: "Terms of Service",
    apply: "apply."
  },
  es: {
    protect: "Este sitio esta protegido por reCAPTCHA y la Google",
    privacyPolicy: "Politica de Privacidad",
    and: "y",
    termsOfService: "Condiciones del Servicio",
    apply: "se aplican."
  },
  fr: {
    protect: "Ce site est protégé par reCAPTCHA et par la Google",
    privacyPolicy: "Politique de confidentialité",
    and: "et",
    termsOfService: "Conditions d'utilisation",
    apply: "s'appliquent."
  }
};

var RecaptchaDisclaimer = function RecaptchaDisclaimer(_ref) {
  var language = _ref.language;
  var Content = exports.RecaptchaContent[language];
  return (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
    css: {
      marginBottom: 20
    },
    size: "sm",
    children: [Content.protect, "\xA0", (0, jsx_runtime_1.jsx)("a", {
      href: "https://policies.google.com/privacy",
      children: Content.privacyPolicy
    }), "\xA0", Content.and, "\xA0", (0, jsx_runtime_1.jsx)("a", {
      href: "https://policies.google.com/terms",
      children: Content.termsOfService
    }), " ", Content.apply]
  });
};

exports.RecaptchaDisclaimer = RecaptchaDisclaimer;